export const mq = {
  sm: "@media (min-width: 576px)",
  md: "@media (min-width: 768px)",
  lg: "@media (min-width: 1200px)",
  xl: "@media (min-width: 1440px)",
};

export const bp = {
  sm: 576,
  md: 768,
  lg: 1200,
  xl: 1440,
};
